import PopupDetailContainer from './PopupDetailContainer';
export default PopupDetailContainer;
